import { RootState } from "src/shared/types/src";

export const getAccountBalance = (state: RootState) => state?.account?.balance || '';

export const getAccountDeposit = (state: RootState) => state?.account?.depositAmount || '';

export const getCurrency = (state: RootState) => state?.account?.currency || '';

export const getTransactions = (state: RootState) => state?.account?.transactions || [];

export const getTransactionsLoading = (state: RootState) => state?.account?.transactionsLoading || false;

export const getBillPayer = (state: RootState) => state?.account?.isBillPayer || false;

export const getPaymentGatewayConfig = (state: RootState) => state?.account?.paymentGateway;

export const getPaymentMethodsForChild = (state: RootState) => state?.account?.paymentMethodsForChild || [];

export const getPaymentMethodsForNursery = (state: RootState) => state?.account?.paymentMethodsForNursery || [];

